(() => {
  const root = document.querySelector('[data-ub-bmx-story]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clips = [...root.querySelectorAll('[data-ub-bmx-loop],[data-ub-bmx-auto]')];
  const states = new WeakMap(clips.map(video => [video, {inView:false,userPaused:false,internalPauses:0}]));
  const load = video => {
    if (!video.dataset.src || video.hasAttribute('src')) return;
    video.src = video.dataset.src;
  };
  const pauseInternally = video => {
    if (video.paused) return;
    states.get(video).internalPauses++;
    video.pause();
  };
  const playWhenAllowed = video => {
    const state = states.get(video);
    if (reducedMotion.matches || state.userPaused || !state.inView || document.hidden) return;
    load(video);
    video.play().catch(() => { /* Native controls remain available. */ });
  };
  if (!('IntersectionObserver' in window)) {
    clips.forEach(load);
    return;
  }
  const loader = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      load(entry.target);
      loader.unobserve(entry.target);
    }
  }, { rootMargin: '300px' });
  const playback = new IntersectionObserver(entries => {
    for (const entry of entries) {
      const video = entry.target;
      const state = states.get(video);
      state.inView = entry.isIntersecting && entry.intersectionRatio >= 0.15;
      if (state.inView) playWhenAllowed(video);
      else pauseInternally(video);
    }
  }, { threshold: 0.15 });
  clips.forEach(video => {
    video.addEventListener('play', () => {
      video.dataset.started = 'true';
      states.get(video).userPaused = false;
    });
    video.addEventListener('pause', () => {
      const state = states.get(video);
      if (state.internalPauses > 0) state.internalPauses--;
      else if (!video.ended) state.userPaused = true;
    });
    loader.observe(video);
    playback.observe(video);
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) clips.forEach(pauseInternally);
    else clips.forEach(playWhenAllowed);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) clips.forEach(pauseInternally);
    else clips.forEach(playWhenAllowed);
  });
})();
